export default __webpack_public_path__ + "static/media/conveni_D.58c3cc50.jpg";